<template>
  <div class="w-full h-full">
    <div class="w-full h-full">
      <div id="previewpage" class="w-full h-full">
        <div :class="bannieres.length > 0 ? 'md:h-[84%]':'h-full'" class=" w-full flex md:flex-row flex-col relative">
          <!-- right part -->

          <div class="md:w-[40%] h-full py-2">
            <div class="w-full flex  items-center py-3  px-8">
              <div class="flex flex-row w-36 gap-2">
                <router-link to="/" class="w-full  text-[14px] font-medium text-gray-500">{{ $t('accueil') }} ></router-link>
                <div href="" class="  text-[14px] font-bold w-44 text-gray-500">{{ $t('produit') }} ></div>
              </div>
            </div>
            <div class=" px-8 flex flex-col gap-4">
              <div class="flex flex-row gap-3 items-center">
                <img src="/icons/icons8_add_book.png" class="h-6 w-5 mt-2" alt="image">
                <span class="lg:text-xl text-center text-[12px]">{{ $t('ajoutdunnouveauproduit') }}</span>
              </div>
              <div>
                <div class="flex items-center space-x-1" v-if="messageMaximunImage == true">
                  <img class="w-6 h-6" src="/icons/error.png" alt="" srcset="">
                  <p class="text-red-500 text-sm">{{ $t('lemaximundimageautoriseeestde5') }}.</p>
                </div>
                <div class=" h-96 p-1  border-2 border-dashed border-[#FF9900] rounded-lg">
                  <div @drop="dropImage" class="w-full h-full bg-gray-200 rounded-lg flex items-center justify-center relative">
                    <div v-if="nbrImage == 0" class="w-full flex flex-col items-center justify-center absolute">
                      <img src="/icons/Group_121.png" alt="">
                      <label for="images" class="text-center text-gray-500 text-sm lg:text-base cursor-pointer">{{
                        $t('cliquezouglissezpourajouterdesimages') }}</label>
                      <input required @change="addimages" type="file" name="images" accept="image/*" id="images"
                        class="hidden" multiple>
                    </div>
                    <div v-if="selectImages" class="w-full h-full overflow-hidden rounded-lg">
                      <img class="object-cover object-center w-full h-full" :src="selectImages" >
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="nbrImage > 0" class="w-full flex flex-row  gap-3">
                <div class="flex items-center space-x-1 lg:space-x-2 w-[19%] lg:w-[15%]">
                  <img class="h-6" src="/icons/icons8_image_file@2x.png" alt="">
                  <div class="text-gray-500 text-sm"><span class="text-lg font-semibold text-black">{{ nbrImage }}</span>/5
                  </div>
                </div>
                <div class="flex w-[81%]">
                  <div
                    :class="(nbrImage >= 3 && nbrImage < 5 ? 'w-[75%] overflow-x-auto' : 'w-auto') || (nbrImage == 5 ? 'w-full overflow-x-auto' : 'w-auto')"
                    class="cursor-pointer flex space-x-1 overflow-hidden">
                    <swiper :slidesPerView="'auto'" :spaceBetween="10" :freeMode="true" :modules="modules" class="mySwiper">
                      <swiper-slide v-for="(image, index) in readimages" :key="image.id"
                        class="swiper-slide-list-images w-28 h-14 relative">
                        <img @click="removeImage(index)" class="w-4 h-4 absolute right-1 top-1 cursor-pointer"
                          src="/icons/deleteimage.png" alt="" srcset="">
                        <img :src="image" @click="selectImages = image"
                          class="w-full h-full object-cover object-center  rounded-lg">
                      </swiper-slide>
                    </swiper>
                  </div>
                  <input @change="addimages" type="file" name="images" accept="image/*" id="images" class="hidden" multiple>
                  <label v-if="nbrImage < 5" for="images"
                    class="w-[25%] h-14 shadow-lg bg-gray-200 rounded-lg flex items-center justify-center text-2xl cursor-pointer">+</label>
                </div>
              </div>

            </div>
          </div>

          <!-- left part -->
          <div class="md:w-[60%] h-full py-2">
            <div class=" h-full w-full flex flex-col relative">
              <div class="w-full xl:px-5 px-3 h-[10%] xl:flex xl:flex-row md:flex-col xl:gap-0 md:gap-3 space-y-1 md:space-y-0 ">
                <div class="xl:w-1/2 md:w-full flex items-center ">
                  <span class="text-[1.6em]">{{ $t('produit') }} N°{{ user.nbr_article + 1 }}</span> <span>- {{ date.getDate() < 10 ? '0'+date.getDate():date.getDate() }}/{{ (date.getMonth() < 10 ? '0'+(date.getMonth() + 1):date.getMonth() + 1) }}/{{ date.getFullYear() }}</span>
                </div>
                <div class="xl:w-1/2  w-full  flex flex-row items-center  gap-2 xl:pl-4 ">
                  <img src="/icons/warning.png" class="md:w-5 md:h-5 xl:w-6 xl:h-6  w-8 h-8" alt="">
                  <input v-model="status_enchere" type="checkbox" class="accent-[#ff9900] xl:h-5 h-4 w-4 xl:w-5">
                  <span class="text-[12px]">{{ $t('pourrecevoirlespropositionsdeprixactiverlesencheres') }}</span>
                </div>
              </div>
              <form @submit.prevent="AddArticle" class="h-[90%] space-y-3 mt-4 md:mt-0 flex flex-col relative py-0">
                <div class=" h-full relative  justify-between xl:px-4 px-3 space-y-2 md:space-y-0 gap-3 md:py-3 overflow-y-auto">
                  <div class="flex flex-col xl:flex-row w-full gap-2 ">
                    <div class=" flex-1 flex flex-col w-full gap-1">
                      <label for="" class="flex-none">{{ $t('categories') }}</label>
                      <select v-if="Object.keys(user).length > 0" @change="cleanForm" v-model="selectCategorie" class="rounded-lg bg-gray-200 h-12  px-5 outline-none" name="" id="">
                        <option v-for="categorie in categories.filter(item => item.autorisation.includes(user.type.toString()))" :key="categorie.id" :value="categorie">{{
                          JSON.parse(categorie.nom)[langue] }}</option>
                      </select>
                    </div>
                    <div class=" flex-1 flex flex-col w-full gap-1 ">
                      <label for="">{{ $t('ville') }}</label>
                      <select v-model="form.ville" name="" id="" class="rounded-lg  bg-gray-200 h-12 px-5 outline-none">
                        <option v-for="ville in villes.sort()" :key="ville.id" :value="ville">{{ ville }}</option>
                      </select>
                    </div>
                  </div>
                  <div v-if="selectCategorie" class=" gap-3 grid xl:grid-cols-2 grid-cols-1 w-full flex-wrap justify-between" :key="selectCategorie.id"> 
                    <div v-for="field in JSON.parse(selectCategorie.input).filter(item => ((item.champ == 'prix_minimal_enchere' &&  status_enchere == true) || item.champ!='prix_minimal_enchere'))" :key="field.id" class="flex flex-col lg:gap-3 gap-5">
                      <label v-if="field.label" :for="field.champ">
                        {{ JSON.parse(field.label)[langue] }}
                        <span v-if="form[field.champ] && field.type == 'number'">: <span class="text-green-500 text-xs">{{ form[field.champ] }}{{ field.unite }}</span></span>
                      </label>
                      <input @keyup="verifyNumericWrite(field.type, field.champ)" :step="field.step" v-if="field.type != 'textarea' && field.type != 'select'" v-model="form[field.champ]" :id="field.champ" 
                        :type="field.type" :min="field.min" :max="field.max" :minlength="field.minlength" :maxlength="field.maxlength" required  class="rounded-lg bg-gray-200 h-12 px-5 outline-none"
                        :placeholder="JSON.parse(field.placeholder)[langue]" style="-moz-appearance:textfield">
                      <select v-if="field.type == 'select'" v-model="form[field.champ]" name="" id="" class="rounded-lg  bg-gray-200 h-12 px-5 outline-none">
                        <option class=" first-letter:uppercase" value="">{{ $t('faiteunchoix') }}</option>
                        <option v-for="option in JSON.parse(field.option)" :key="option.id" :value="option['value'+langue]" class=" first-letter:uppercase">{{ option['value'+langue] }}</option>
                      </select>
                      <textarea v-if="field.type == 'textarea'" v-model="form[field.champ]" required  class="rounded-lg  bg-gray-200 h-12 px-5 outline-none"
                        :placeholder="JSON.parse(field.placeholder)[langue]"></textarea>
                    </div>
                  </div>
                </div>
                <div class="w-full  pl-5 flex lg:flex-row flex-col px-5 space-y-4 xl:space-y-0">
                  <div class="lg:w-1/2 flex flex-col gap-3">
                    <div class="w-full flex flex-row items-center gap-5">
                      <input v-model="confidentAccept" type="checkbox" class="w-5 h-5 accent-[#ff9900]">
                      <span class="w-[90%] text-[12px]">{{ $t('accepteterme') }} {{ $t('consulterlestermes') }}</span>
                    </div>
                    <div class=" w-full flex flex-row  items-center gap-5">
                      <input v-model="notificationAcheteurAccept" type="checkbox" class="w-5 h-5 accent-[#ff9900]">
                      <span class="w-[90%] text-[12px]">{{ $t('recevoirdesnotificationsdacheteurspotentiels') }}</span>
                    </div>
                  </div>
                  <div class="lg:w-1/2 w-full flex xl:justify-end justify-center relative">
                    <div  class="flex flex-col w-full">
                      <div class="flex items-center space-x-1 mx-auto" v-if="this.form.image.length == 0 && noImage == true">
                        <img class="w-6 h-6" src="/icons/error.png" alt="" srcset="">
                        <p class="text-red-500 text-sm text-center">{{$t('selectionnerdesimagesdelarticlepourlepublier') }}</p>
                      </div>
                      <button :class="user.status == 'block' ? 'opacity-70':'opacity-100'" :disabled="AddLoading == false && form.image.length <= 5 && confidentAccept && notificationAcheteurAccept && user.status != 'block' ? false:true"  class=" w-full bg-[#ff9900] hover:text-black hover:bg-transparent hover:border-[2px] hover:border-[#ff9900] h-12 rounded-lg text-white ">
                        <p v-if="AddLoading == false">{{$t('publiercetarticle') }}</p>
                      </button>
                    </div>
                    <button v-if="AddLoading == 'oui' && form.image.length <= 5"
                      class="w-full flex items-center bg-green-500 h-12 rounded-lg absolute">
                      <img class="w-6 h-6 mx-auto" src="/icons/checked.png" alt="" srcset="">
                    </button>
                    <div v-if="AddLoading == 'non' && form.image.length <= 5" class="rounded-lg absolute flex items-center justify-center border-[#FF9900] border-2 text-white  w-full mx-auto h-12 text-center">
                      <svg aria-hidden="true"
                        class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-white fill-[#FF9900]"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor" />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill" />
                      </svg>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div v-if="bannieres.length > 0" class="h-[16%] w-full flex items-center justify-center">
          <div class="w-[95%] bg-gray-400 flex items-center h-full justify-center">
            <!-- <button class="w-full text-white text-[16px] h-full font-medium">{{ $t('bannierepublicitaire') }}</button> -->
            <swiper
              :modules="modules"
              class="mySwiper" 
              :loop="true"
              :autoplay="true"
            >
              <swiper-slide @click="openLink(banniere.lien)" v-for="banniere in bannieres" :key="banniere.id"  class="w-full h-full swiper-slide-image-article cursor-pointer">
                <img class="w-full h-full object-fill hidden xl:block" :src="JSON.parse(banniere.images)['web']" loading="lazy">
                <img class="w-full h-full object-fill hidden md:block xl:hidden" :src="JSON.parse(banniere.images)['tablette']" loading="lazy">
                <img class="w-full h-full object-fill md:hidden" :src="JSON.parse(banniere.images)['mobile']" loading="lazy">
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
// Import Swiper styles
import 'swiper/css';

import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, FreeMode, Navigation } from 'swiper';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, FreeMode, Navigation],
    };
  },

  data() {
    return {
      date: new Date(),
      images: [],
      readimages: [],
      confidentAccept:false,
      notificationAcheteurAccept:false,
      nbrImage: 0,
      selectImages: '',
      categories: [],
      langue: '',
      selectCategorie: '',
      AddLoading: '',
      noImage: false,
      messageMaximunImage: false,
      status_enchere:false,
      form: {
        nom: '',
        marque: '',
        couleur: '',
        taille: '',
        stockage: '',
        pixe_camera_avant: '',
        pixel_camera_arriere: '',
        ram: '',
        cpu: '',
        model_cpu: '',
        systeme_exploitation: '',
        carte_graphique_dedie: '',
        model_carte_graphique_dedie: '',
        etat: '',
        taille_pouce: '',
        quantite_litre: '',
        quartier: '',
        superficie: '',
        nombre_piece: '',
        nombre_chambre: '',
        nombre_salon: '',
        nombre_douche: '',
        nombre_cuisine: '',
        prix_minimal_enchere: '',
        prix:'',
        numero_direct: '',
        numero_whatsapp: '',
        description: '',
        ville: '',
        essence: '',
        status_enchere: false,
        categorie_id: '',
        image: [],
        empreinte:''
      },
      villes: [],
      user:{},
      oldValue:[],
      bannieres:[]
    }
  },

  watch: {
    requestAccueil: {
      handler(newValue) {
        this.categories = newValue[2]
        if (this.selectCategorie == '') {
          this.selectCategorie = newValue[2][0]
        }
      },
      deep: true
    },
    status_enchere: {
      handler(newValue) {
        if(newValue){
          this.form.prix_minimal_enchere = ''
        }
      },
      deep: true
    },
  },
  created(){
    window.addEventListener('drop',(e)=>{
      e.preventDefault()
    })
    window.addEventListener('dragover',(e)=>{
      e.preventDefault()
    })
  },
  mounted() {
    this.requestAuth == 'NotAuth' ? this.$router.push('/'):''
    this.bannieres = this.requestBanniere
    this.user = this.$store.state.dataAccueil[0]
    this.$store.state.preview = document.getElementById('previewpage')
    this.villes = this.$store.state.villes
    this.langue = localStorage.getItem('langue');
    this.form.ville = this.user.ville
    this.categories = this.requestAccueil[2]
    this.selectCategorie = this.requestAccueil[2][0]
  },
  methods: {
    addimages(allimages) {
      
      if (this.form.image.length + allimages.target.files.length <= 5) {
        this.messageMaximunImage = false
        for (let i = 0; i < allimages.target.files.length; i++) {
          this.form.image.push(allimages.target.files[i])
          this.readimages.push(URL.createObjectURL(allimages.target.files[i]))
        }

        this.selectImages = this.readimages[0]
        this.nbrImage = this.readimages.length

      } else {
        this.messageMaximunImage = true
      }
    },

    AddArticle() {
      if (this.form.image.length > 0 && this.form.image.length <= 5) {
        this.noImage = false
        this.AddLoading = 'non'
        let article = new FormData();
        this.form.categorie_id = this.selectCategorie.id
        article.append('nom', this.form.nom);
        article.append('marque', this.form.marque);
        article.append('couleur', this.form.couleur);
        article.append('taille', this.form.taille);
        article.append('ville', this.form.ville);
        article.append('stockage', this.form.stockage);
        article.append('pixe_camera_avant', this.form.pixe_camera_avant);
        article.append('pixel_camera_arriere', this.form.pixel_camera_arriere);
        article.append('ram', this.form.ram);
        article.append('empreinte', this.form.empreinte);
        article.append('cpu', this.form.cpu);
        article.append('systeme_exploitation', this.form.systeme_exploitation);
        article.append('carte_graphique_dedie', this.form.carte_graphique_dedie);
        article.append('etat', this.form.etat);
        article.append('taille_pouce', this.form.taille_pouce);
        article.append('quantite_litre', this.form.quantite_litre);
        article.append('quartier', this.form.quartier);
        article.append('superficie', this.form.superficie);
        article.append('nombre_piece', this.form.nombre_piece);
        article.append('nombre_chambre', this.form.nombre_chambre);
        article.append('nombre_salon', this.form.nombre_salon);
        article.append('nombre_douche', this.form.nombre_douche);
        article.append('nombre_cuisine', this.form.nombre_cuisine);
        article.append('prix_minimal_enchere', this.form.prix_minimal_enchere);
        article.append('prix', this.form.prix);
        article.append('numero_direct', this.form.numero_direct);
        article.append('numero_whatsapp', this.form.numero_whatsapp);
        article.append('quantite_disponible', this.form.quantite_disponible);
        article.append('description', this.form.description);
        article.append('status_enchere', this.form.status_enchere);
        article.append('categorie_id', this.form.categorie_id);
        article.append('langue', this.langue);
        for (let i = 0; i < this.form.image.length; i++) {
          article.append('image[]', this.form.image[i]);
        }
        this.axios.post(this.requestHttp + 'save_article', article, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
          },
        }).then(({ data }) => {
          this.AddLoading = 'oui'
          if(this.$store.state.toutMesArticles[0]?.data.length > 0){
            this.$store.state.toutMesArticles[0].data.unshift(data)
          }
          if(this.$store.state.mesArticlesEnVentes[0]?.data.length > 0){
            this.$store.state.mesArticlesEnVentes[0].data.unshift(data)
          }
          if(this.$store.state.dataArticles.length > 0){
            var article = data
            article.user = this.user
            console.log(this.$store.state.dataArticles)
            this.$store.state.dataArticles.unshift(article)
          }
          
          setTimeout(() => {
            this.user.nbr_article = this.user.nbr_article + 1
            this.$router.push('/mes-articles');
          }, 1000);
        }).catch(
          error => {
            this.AddLoading = ''
            if(error){
              this.errors = error.response.data.message
            }
          })
      } else {
        if (this.form.image.length <= 5) {
          this.noImage = true
        } else {
          this.messageMaximunImage = true
        }
      }
    },
    removeImage(index) {
      this.form.image.splice(index, 1)
      this.readimages.splice(index, 1)
      this.nbrImage = this.readimages.length
      this.selectImages = this.readimages[0]
      if (this.form.image.length <= 5) {
        this.messageMaximunImage = false
      }
    },
    dropImage(e){
      const files = [...e.dataTransfer.files]
      const accept = ['png', 'jpg', 'jpeg', 'webp', 'svg', 'gif']
      if (this.form.image.length + files.length <= 5) {
        for(let i = 0; i < files.length; i++) {
          const extension = files[i].type.split('/')[1]
          if(!accept.includes(extension)){
            alert("mettez une image")
          }else{
            this.form.image.push(files[i])
            this.readimages.push(URL.createObjectURL(files[i]))
            this.selectImages = this.readimages[0]
            this.nbrImage = this.readimages.length

            this.messageMaximunImage = false
          } 
        }
      }else{
        this.messageMaximunImage = true
      }
    },
    cleanForm(){
      this.form = Object.keys(this.form).reduce((acc, curr) => {
          if(curr == 'ville')return { ...acc, [curr]: this.form[curr] }
          if(curr == 'image')return { ...acc, [curr]: this.form[curr] }
          if (this.form[curr] === null) return { ...acc, [curr]: null };
          if (typeof this.form[curr] === 'undefined') return { ...acc, [curr]: undefined };
          if (typeof this.form[curr] === 'boolean') return { ...acc, [curr]: false };
          if (typeof this.form[curr] === 'string') return {...acc, [curr]: ''};
          if (typeof this.form[curr] === 'number') return {...acc, [curr]: 0};
          if (this.form[curr] instanceof Array) return { ...acc, [curr]: [] };
          if (typeof this.form[curr] === 'object') return { ...acc, [curr]: {} };
      }, {})
    },
    verifyNumericWrite(type, champ){
      if(type == 'number'){
        if(event.key.length == 1){
          event.key.match(/^(?=.*[0-9])/) ? this.oldValue[champ] = this.form[champ]:document.getElementById(champ).value  = this.oldValue[champ],this.form[champ]= this.oldValue[champ]
        }else{
          this.oldValue[champ] = this.form[champ]
        }
      }
    },
    openLink(link){
      window.open(link)
    },
  },
  computed: {
    requestAuth() {
      return this.$store.state.auth
    },
    requestHttp() {
      return this.$store.state.api
    },
    requestAccueil() {
      return this.$store.state.dataAccueil
    },
    requestFile(){
      return this.$store.state.apifile
    },
    requestBanniere(){
      return this.$store.state.bannieres
    },
  }
}
</script>

<style>
.swiper {
  width: 100%;
  height: 100%;
  position: inherit !important
}

.swiper-slide-list-images {
  text-align: center;
  font-size: 18px;
  width: 7rem !important;
  height: 3.5rem !important;
  border-radius: 9px;
  overflow: hidden;
  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>